@if (building() && (!showLabel() || buildingLabel())) {
  <cfp-card [dataTest]="'summaryBuilding'">
    <ng-content />
    <h2 [class.mb-0]="showSubTitle()">{{ header() | translate }}</h2>
    @if (showSubTitle()) {
      <em class="d-block mb-4">
        <small [class]="textColor()">
          <cfp-translated-router-link
            [text]="'checkYourBuildingSubTitle'"
            [link]="`/energy/${portfolioId()}/buildings/${buildingId()}/properties`"
            [fragment]="fragment()"
          />
        </small>
      </em>
    }
    <div class="row">
      <div class="col-6 col-md mb-3 mb-md-0">
        <h5>{{ 'buildingYear' | translate }}</h5>
        <span [constructionPeriod]="building()"></span>
      </div>
      <div class="col-6 col-md mb-3 mb-md-0">
        <h5>{{ 'area' | translate }}</h5>
        <cfp-measurement-area [value]="building().area" />
      </div>
      @if (showObjectType()) {
        <div class="col-6 col-md mb-3 mb-md-0">
          <h5>{{ 'function' | translate }}</h5>
          {{ 'objecttype.' + building().objectType | translate }}
        </div>
      }
      @if (showSubObjectType()) {
        <div class="col-6 col-md mb-3 mb-md-0">
          <h5>{{ 'function' | translate }}</h5>
          {{
            building().subObjectType | translateSubObjectType: building().objectType : building().address.countryCode
          }}
        </div>
      }
      <div class="col-6 col-md mb-3 mb-md-0">
        <h5>{{ 'building.energylabel.electricity' | translate }}</h5>
        {{ building().totalElectricityConsumption | number: '1.0-0' }} kWh
      </div>
      @if (energyConsumptionHelper.usesGas(building().heatingConsumptionType, building().hotWaterType)) {
          <div class="col-6 col-md mb-3 mb-md-0">
            <h5>{{ 'building.energylabel.gas' | translate }}</h5>
            {{
              building().totalGasConsumption
                | gasUnitsConversion: building().address.countryCode : building().address.regionCode
                | async
                | number: '1.0-0'
            }}
            <span [innerHTML]="unitsConversionHelper.gasUnitsHtml()"></span>
          </div>
      }
      @if (energyConsumptionHelper.usesDistrictHeating(building().heatingConsumptionType, building().hotWaterType)) {
          <div class="col-6 col-md mb-3 mb-md-0">
            <h5>{{ 'building.energylabel.heatusage' | translate }}</h5>
            {{
              building().totalHeatConsumption
                | heatUnitsConversion: building().address.countryCode : building().address.regionCode
                | async
                | number: '1.0-0'
            }}
            {{ unitsConversionHelper.heatUnits() }}
          </div>
      }
      @if (energyConsumptionHelper.usesOil(building().heatingConsumptionType, building().hotWaterType)) {
          <div class="col-6 col-md mb-3 mb-md-0">
            <h5>{{ 'building.energylabel.oilusage' | translate }}</h5>
            {{
              building().totalOilConsumption
                | oilUnitsConversion: building().address.countryCode : building().address.regionCode
                | async
                | number: '1.0-0'
            }}
            {{ unitsConversionHelper.oilUnits() }}
          </div>
      }
      @if (energyConsumptionHelper.usesWood(building().heatingConsumptionType, building().hotWaterType)) {
          <div class="col-6 col-md mb-3 mb-md-0">
            <h5>{{ 'building.energylabel.woodconsumption' | translate }}</h5>
            {{
              building().totalWoodConsumption
                | woodUnitsConversion: building().address.countryCode : building().address.regionCode
                | async
                | number: '1.0-3'
            }}
            <span [innerHTML]="unitsConversionHelper.woodUnitsHtml()"></span>
          </div>
      }
      @if (energyConsumptionHelper.usesPellet(building().heatingConsumptionType, building().hotWaterType)) {
          <div class="col-6 col-md mb-3 mb-md-0">
            <h5>{{ 'building.energylabel.pelletconsumption' | translate }}</h5>
            {{
              building().totalPelletConsumption
                | pelletUnitsConversion: building().address.countryCode : building().address.regionCode
                | async
                | number: '1.0-3'
            }}
            {{ unitsConversionHelper.pelletUnits() }}
          </div>
      }
      @if (energyConsumptionHelper.usesCoal(building().heatingConsumptionType, building().hotWaterType)) {
          <div class="col-6 col-md mb-3 mb-md-0">
            <h5>{{ 'building.energylabel.coalconsumption' | translate }}</h5>
            {{
              building().totalCoalConsumption
                | coalUnitsConversion: building().address.countryCode : building().address.regionCode
                | async
                | number: '1.0-3'
            }}
            {{ unitsConversionHelper.coalUnits() }}
          </div>
      }
      @if (showEnergyCosts()) {
        <div class="col-6 col-md mb-3 mb-md-0">
          <h5>{{ 'energyCosts' | translate }}</h5>
          {{ building().totalEnergyCosts | cfpCurrency: building().currencyCode }}
        </div>
      }
      @if (showCo2Consumption()) {
        <div class="col-6 col-md mb-3 mb-md-0">
          <h5 [innerHTML]="'co2Consumption' | translate"></h5>
          {{ building().totalCo2Consumption | co2: false }}
        </div>
      }
    </div>
    @if (showLabel() || showDescription()) {
      <div class="row mt-3 pt-4">
        @if (showLabel()) {
          <div class="col-12 col-md-4">
            <div class="alert alert-primary">
              <div class="row">
                <div class="col my-auto">
                  {{
                    (buildingLabel().currentLabel.registrationDate
                      ? 'energy.label.certified'
                      : 'energy.label.calculated'
                    ) | translate: { labelGroupRating: 'labelGroup.rating.' + labelGroup() | translate }
                  }}
                </div>
                <div class="col-auto">
                  <cfp-energy-label
                    [energyLabel]="{
                      label: building().address.monument
                        ? 'monument'
                        : building().objectType === ObjectTypeDTO.PARKING
                          ? 'parking'
                          : buildingLabel().currentLabel.label,
                      index: buildingLabel().currentLabel.index,
                      indexType: buildingLabel().currentLabel.indexType,
                      validUntil: buildingLabel().currentLabel.validUntil
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        }
        @if (showDescription()) {
          <div class="col-12" [class]="showLabel() ? 'offset-md-1 col-md-7' : undefined">
            <h5>
              {{
                'buildingSummary.title'
                  | translate: { address: building().address, displayAddress1: building().address.display[0] }
              }}
            </h5>
            <p
              class="mb-0 text-preline"
              [innerHtml]="buildingReport()?.description || defaultBuildingReportDescription() | sanitizeHtml"
            ></p>
          </div>
        }
      </div>
    }
    <div class="building-summary-card-bottom">
      <ng-content select="[bottom]" />
    </div>
  </cfp-card>
}
